<div
  class="min-h-screen mx-auto px-4 flex flex-col"
  *ngIf="config"
  [class.max-w-5xl]="config.screenRatio < 1"
  [class.max-w-xl]="config.screenRatio >= 1"
>
  <div id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo">
  </div>

  <content-block [slug]="'default-disabled-top'" id="default-disabled-top-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-disabled-top'" id="wbm-disabled-top-wrapper" [class.hidden]=" ! boothMode"></content-block>


  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-disclaimer-bottom'" id="wbm-disclaimer-bottom-wrapper" [class.hidden]=" ! boothMode"></content-block>
</div>
